var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentAdd = function SvgDocumentAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 24H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h20c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2z",
    style: {
      fill: "#8bacff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "document_add_svg__st1",
    d: "M18.9 7.8h-7.6l-1.1-1.6c-.2-.3-.5-.4-.8-.4H4.9c-.5 0-.9.4-.9.9v11c0 .6.5 1.1 1.1 1.1h13.8c.6 0 1.1-.5 1.1-1.1V8.9c0-.6-.5-1.1-1.1-1.1zm-4.4 6.5h-1.6v1.6c0 .5-.4.8-.8.8s-.8-.4-.8-.8v-1.6H9.5c-.5 0-.8-.4-.8-.8 0-.5.4-.8.8-.8h1.6V11c0-.5.4-.8.8-.8s.8.4.8.8v1.6h1.6c.5 0 .8.4.8.8.2.5-.2.9-.6.9z"
  })));
};
export default SvgDocumentAdd;